<template>
  <div class="layout-container" id="app">
    <!-- 1. 头部区域 -->
    <header class="main-header">
      <div class="header-content">
        <div class="d-flex flex-align-center">
          <img src="./assets/logo.png" alt="logo">
          <h1>Freiwallet</h1>
        </div>
        <!-- 导航菜单示例 -->
        <nav>
          <router-link to="/">首页</router-link>
          <router-link to="/about">关于</router-link>
          <router-link to="/contact">联系</router-link>
        </nav>
      </div>
    </header>

    <!-- 2. 主体内容区域 -->
    <!-- 这里是路由视图，会根据 URL 动态加载不同的页面组件 -->
    <main class="main-content">
      <router-view></router-view>
    </main>

    <!-- 3. 底部区域 -->
    <footer class="main-footer">
      <div class="footer-content">
        <p>© 2026 www.freiwallet.com. 保留所有权利</p>
        <p>地址：湖南 | QQ：2015901453</p>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'MainLayout',
  // 这里可以放置一些全局的布局逻辑，例如用户登录状态检查等
  mounted() {
    console.log('主布局已加载');
  }
}
</script>

<style scoped>
/* 基础样式重置与布局 */
.layout-container {
  min-height: 100vh; /* 占满视口高度 */
  display: flex;
  flex-direction: column;
  font-family: Arial, sans-serif;
  background: #181928;
}

/* 头部样式 */
.main-header {
  background-color: #2f3045;
  color: #03e1e4;
  padding: 1rem 0;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.header-content {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
}

.header-content img{
  width: 3rem;
  height: 3rem;
}

.header-content h1 {
  margin: 0 0.6rem;
  font-size: 1.5rem;
}

.header-content nav a {
  color: #03e1e4;
  margin-left: 15px;
  text-decoration: none;
  transition: all 0.2s;
}

.header-content nav a:hover {
  /* text-decoration: underline; */
  transform: scale(1.2);
}

/* 内容区域：占据剩余空间 */
.main-content {
  flex: 1; /* 关键属性：让内容区域撑开，防止 footer 上移 */
}

/* 底部样式 */
.main-footer {
  background-color: #2f3045;
  color: #ccc;
  text-align: center;
  padding: 20px 0;
  margin-top: auto; /* 如果使用 flex 布局，这会将 footer 推到底部 */
  font-size: 0.9rem;
}
</style>